<template>
  <div class="user-wrapper">
<!--    <header-online class="action"/>-->
<!--    <header-notice class="action"/>-->
    <a-dropdown>
      <span class="action ant-dropdown-link user-dropdown-menu">
        <a-avatar class="avatar" size="small" :src="avatar()"/>
        <span>{{ nickname() }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
<!--        <a-menu-item key="1">-->
<!--          <router-link :to="{ name: 'settings' }">-->
<!--            <a-icon type="setting"/>-->
<!--            <span>账户设置</span>-->
<!--          </router-link>-->
<!--        </a-menu-item>-->
<!--        <a-menu-divider/>-->
        <a-menu-item key="3">
          <a href="javascript:;" @click="handleLogout">
            <a-icon type="logout"/>
            <span>退出登录</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
// import HeaderNotice from './HeaderNotice'
// import HeaderOnline from './HeaderOnline'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UserMenu',
  components: {
    // HeaderNotice,
    // HeaderOnline
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar']),
    handleLogout () {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
            return that.Logout({}).then(() => {
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .header-online {
    display: inline-block;
    transition: all 0.3s;

    span {
      vertical-align: initial;
    }
  }
</style>
